import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export * from './BuildInfoModal';
export * from './SidebarBuildInfo';
export * from './SystemInfoPage';

export const systemInfoPage = PageBlueprint.make({
  name: 'diagnostics',
  params: {
    path: '/diagnostics',
    loader: async () =>
      import('./SystemInfoPage').then(m => <m.SystemInfoPage />),
  },
});

export const systemInfoModule = createFrontendModule({
  pluginId: 'app',
  extensions: [systemInfoPage],
});
